import React, { useState } from "react";
import { HumanPracticesItems } from "./NavItems";
import { Link } from "react-router-dom";
import "./Dropdown.css";
import GoToTop from "./GoToTop";

function DropdownH() {
  const [dropdownH, setDropdownH] = useState(false);

  return (
    <>
      <ul
        className={dropdownH ? "submenu clicked" : "submenu"}
        onClick={() => setDropdownH(!dropdownH)}
      >
        {HumanPracticesItems.map((item) => {
          return (
            <li key={item.id}>
              <Link
                to={item.path}
                className={item.cName}
                onClick={() => {setDropdownH(false);GoToTop();}}
              >
                {item.title}
              </Link>
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default DropdownH;
